module.exports = __webpack_public_path__ + "static/img/expert-bg.1cbc2995.png";